module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/download_pdf-9e7daf543799b933546424ab91720727.svg&quot;;"